"use client"
import { Link, useNavigate } from "react-router-dom"
import logo from "../assets/images/agapeLOGO.png"
import { useAuth } from "../AuthContext"
import { useCart } from "../context/CartContext"
import { FaShoppingCart } from "react-icons/fa"

function Navbar() {
  const fontStyle = {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontWeight: 500,
    letterSpacing: "0.025em",
    fontSize: "0.95rem",
  }

  const navigate = useNavigate()
  const { currentUser, isAdmin, logout } = useAuth()
  const { itemCount } = useCart()

  const handleLogout = async () => {
    await logout()
    navigate("/sign-in")
  }

  const navbarStyle = {
    background: "#ffffff",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    padding: "0.75rem 0",
    borderBottom: "1px solid rgba(0, 0, 0, 0.05)",
    transition: "all 0.2s ease",
  }

  const logoStyle = {
    height: "60px",
    width: "auto",
    maxWidth: "200px",
    cursor: "pointer",
    objectFit: "contain",
    filter: "drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1))",
    transition: "transform 0.2s ease",
  }

  const navLinkStyle = {
    ...fontStyle,
    color: "#374151",
    textDecoration: "none",
    padding: "0.5rem 1rem",
    borderRadius: "6px",
    transition: "all 0.2s ease",
    position: "relative",
    fontWeight: 500,
  }

  const dropdownStyle = {
    background: "#ffffff",
    border: "1px solid rgba(0, 0, 0, 0.05)",
    borderRadius: "8px",
    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05)",
    padding: "0.5rem 0",
    marginTop: "0.5rem",
  }

  const dropdownItemStyle = {
    ...fontStyle,
    color: "#374151",
    padding: "0.75rem 1.25rem",
    transition: "all 0.2s ease",
    fontSize: "0.9rem",
    fontWeight: 400,
  }

  return (
    <>
      <style jsx>{`
                body {
                    padding-top: 100px !important;
                }
                
                .modern-navbar .nav-link:hover {
                    background: #f3f4f6 !important;
                    color: #111827 !important;
                    transform: translateY(-1px);
                }
                
                .modern-navbar .dropdown-item:hover {
                    background: #f9fafb !important;
                    color: #6b7280 !important;
                    transform: translateX(2px);
                }
                
                .modern-navbar .navbar-toggler {
                    border: 1px solid #e5e7eb;
                    background: #f9fafb;
                    padding: 0.5rem;
                    border-radius: 6px;
                }
                
                .modern-navbar .navbar-toggler:focus {
                    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.5);
                    border-color: #3b82f6;
                }
                
                .modern-navbar .logo:hover {
                    transform: scale(1.02);
                }
                
                .modern-navbar .dropdown-menu {
                    animation: slideDown 0.2s ease;
                }
                
                @keyframes slideDown {
                    from {
                        opacity: 0;
                        transform: translateY(-8px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                
                .modern-navbar .nav-link {
                    position: relative;
                }
                
                .modern-navbar .nav-link::after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    width: 0;
                    height: 2px;
                    background: #6b7280;
                    transition: all 0.2s ease;
                    transform: translateX(-50%);
                }
                
                .modern-navbar .nav-link:hover::after {
                    width: 80%;
                }
            `}</style>

      <nav className="navbar navbar-expand-lg modern-navbar" style={navbarStyle}>
        <div className="container-fluid px-4">
          <img
            src={logo || "/placeholder.svg"}
            alt="Agape Prime Hotel Logo"
            onClick={() => navigate("/")}
            style={logoStyle}
            className="logo"
          />

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNavDropdown">
            <ul className="navbar-nav ms-auto align-items-center">
              <li className="nav-item">
                <Link className="nav-link" to="/rooms" style={navLinkStyle}>
                  Suites & Villas
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/wellness" style={navLinkStyle}>
                  Wellness Center
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/pbpavilion" style={navLinkStyle}>
                  PB Pavilion
                </Link>
              </li>

              <li className="nav-item dropdown">
                <span
                  className="nav-link dropdown-toggle"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={navLinkStyle}
                >
                  Booking
                </span>
                <ul className="dropdown-menu" style={dropdownStyle}>
                  <li>
                    <Link className="dropdown-item" to="/booking" style={dropdownItemStyle}>
                      Reserve a Suite & Villa
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/reserve-wellness" style={dropdownItemStyle}>
                      Reserve Wellness Center
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/reserve-pavilion" style={dropdownItemStyle}>
                      Reserve PB Pavilion
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="https://www.agapeprimehotel.com/WP/about/"
                  style={navLinkStyle}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  About Us
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="https://www.agapeprimehotel.com/WP/contact/"
                  style={navLinkStyle}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Contact
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/faq" style={navLinkStyle}>
                  FAQ
                </Link>
              </li>

              {isAdmin && (
                <li className="nav-item">
                  <Link className="nav-link" to="/admin" style={navLinkStyle}>
                    Admin
                  </Link>
                </li>
              )}

              {currentUser && (
                <li className="nav-item">
                  <Link
                    to="/cart"
                    className="nav-link"
                    style={{ ...navLinkStyle, position: "relative", display: "flex", alignItems: "center", gap: "6px" }}
                  >
                    <FaShoppingCart size={16} />
                    Cart
                    {itemCount > 0 && (
                      <span style={{
                        position: "absolute",
                        top: "2px",
                        right: "2px",
                        background: "#ef4444",
                        color: "#ffffff",
                        borderRadius: "50%",
                        width: "17px",
                        height: "17px",
                        fontSize: "10px",
                        fontWeight: 700,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        lineHeight: 1,
                      }}>
                        {itemCount > 9 ? "9+" : itemCount}
                      </span>
                    )}
                  </Link>
                </li>
              )}

              <li className="nav-item dropdown">
                <span
                  className="nav-link dropdown-toggle"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={navLinkStyle}
                >
                  Account
                </span>
                <ul className="dropdown-menu" style={dropdownStyle}>
                  <li>
                    <Link className="dropdown-item" to="/points" style={dropdownItemStyle}>
                      Rewards
                    </Link>
                  </li>
                  {currentUser ? (
                    <li>
                      <button className="dropdown-item" onClick={handleLogout} style={dropdownItemStyle}>
                        Logout
                      </button>
                    </li>
                  ) : (
                    <>
                      <li>
                        <Link className="dropdown-item" to="/sign-up" style={dropdownItemStyle}>
                          Sign Up
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" to="/sign-in" style={dropdownItemStyle}>
                          Sign In
                        </Link>
                      </li>
                    </>
                  )}
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  )
}

export default Navbar
